import axios from "../lib/axios";

export const createTemplate = async (payload) => {
  try {
    const response = await axios.post(`/sms-templates/create`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getTemplate = async () => {
  try {
    const response = await axios.get(`/sms-templates`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const postSms = async (payload) => {
  try {
    const response = await axios.post(`/sms-templates/send-sms`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getLogs = async ({ limit = 10, lastId } = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (limit) queryParams.append("limit", limit.toString());
    if (lastId) queryParams.append("lastId", lastId);

    const response = await axios.get(
      `/sms-templates/logs?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch SMS logs"
    );
  }
};

// Add these functions to your existing file

export const updateTemplate = async (id, payload) => {
  try {
    const response = await axios.put(`/sms-templates/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update template"
    );
  }
};

export const deleteTemplate = async (id) => {
  try {
    const response = await axios.delete(`/sms-templates/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete template"
    );
  }
};
